module.exports = __webpack_public_path__ + "img/Unidad15-4.494d493d.png";